import { render, staticRenderFns } from "./FlexTable.vue?vue&type=template&id=77489f93&scoped=true"
import script from "./FlexTable.vue?vue&type=script&lang=js"
export * from "./FlexTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77489f93",
  null
  
)

export default component.exports